'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDiffViewer = require('react-diff-viewer');

var _reactDiffViewer2 = _interopRequireDefault(_reactDiffViewer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PracticeTestQuestionImportDiff(_ref) {
    var before = _ref.before,
        after = _ref.after;

    return _react2.default.createElement(
        'div',
        { style: { overflowX: 'auto', marginTop: 12 } },
        _react2.default.createElement(_reactDiffViewer2.default, {
            oldValue: before || '',
            newValue: after || '',
            splitView: true,
            showDiffOnly: false,
            compareMethod: 'diffWords',
            leftTitle: 'Texto pr\xE9-processado',
            rightTitle: 'Texto extra\xEDdo',
            hideLineNumbers: false,
            useDarkTheme: false
        })
    );
}

exports.default = PracticeTestQuestionImportDiff;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvY29tcG9uZW50cy9wcmFjdGljZVRlc3RzL1ByYWN0aWNlVGVzdFF1ZXN0aW9uSW1wb3J0RGlmZi5qcyJdLCJuYW1lcyI6WyJQcmFjdGljZVRlc3RRdWVzdGlvbkltcG9ydERpZmYiLCJiZWZvcmUiLCJhZnRlciIsIm92ZXJmbG93WCIsIm1hcmdpblRvcCJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7Ozs7QUFDQTs7Ozs7O0FBRUEsU0FBU0EsOEJBQVQsT0FBMkQ7QUFBQSxRQUFqQkMsTUFBaUIsUUFBakJBLE1BQWlCO0FBQUEsUUFBVEMsS0FBUyxRQUFUQSxLQUFTOztBQUN2RCxXQUNJO0FBQUE7QUFBQSxVQUFLLE9BQU8sRUFBRUMsV0FBVyxNQUFiLEVBQXFCQyxXQUFXLEVBQWhDLEVBQVo7QUFDSSxzQ0FBQyx5QkFBRDtBQUNJLHNCQUFVSCxVQUFVLEVBRHhCO0FBRUksc0JBQVVDLFNBQVMsRUFGdkI7QUFHSSwyQkFISjtBQUlJLDBCQUFjLEtBSmxCO0FBS0ksMkJBQWMsV0FMbEI7QUFNSSx1QkFBVSx5QkFOZDtBQU9JLHdCQUFXLG1CQVBmO0FBUUksNkJBQWlCLEtBUnJCO0FBU0ksMEJBQWM7QUFUbEI7QUFESixLQURKO0FBZUg7O2tCQUVjRiw4QiIsImZpbGUiOiJQcmFjdGljZVRlc3RRdWVzdGlvbkltcG9ydERpZmYuanMiLCJzb3VyY2VSb290IjoiL3NyYyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgUmVhY3REaWZmVmlld2VyIGZyb20gJ3JlYWN0LWRpZmYtdmlld2VyJztcblxuZnVuY3Rpb24gUHJhY3RpY2VUZXN0UXVlc3Rpb25JbXBvcnREaWZmKHsgYmVmb3JlLCBhZnRlciB9KSB7XG4gICAgcmV0dXJuIChcbiAgICAgICAgPGRpdiBzdHlsZT17eyBvdmVyZmxvd1g6ICdhdXRvJywgbWFyZ2luVG9wOiAxMiB9fT5cbiAgICAgICAgICAgIDxSZWFjdERpZmZWaWV3ZXJcbiAgICAgICAgICAgICAgICBvbGRWYWx1ZT17YmVmb3JlIHx8ICcnfVxuICAgICAgICAgICAgICAgIG5ld1ZhbHVlPXthZnRlciB8fCAnJ31cbiAgICAgICAgICAgICAgICBzcGxpdFZpZXdcbiAgICAgICAgICAgICAgICBzaG93RGlmZk9ubHk9e2ZhbHNlfVxuICAgICAgICAgICAgICAgIGNvbXBhcmVNZXRob2Q9XCJkaWZmV29yZHNcIlxuICAgICAgICAgICAgICAgIGxlZnRUaXRsZT1cIlRleHRvIHByw6ktcHJvY2Vzc2Fkb1wiXG4gICAgICAgICAgICAgICAgcmlnaHRUaXRsZT1cIlRleHRvIGV4dHJhw61kb1wiXG4gICAgICAgICAgICAgICAgaGlkZUxpbmVOdW1iZXJzPXtmYWxzZX1cbiAgICAgICAgICAgICAgICB1c2VEYXJrVGhlbWU9e2ZhbHNlfVxuICAgICAgICAgICAgLz5cbiAgICAgICAgPC9kaXY+XG4gICAgKTtcbn1cblxuZXhwb3J0IGRlZmF1bHQgUHJhY3RpY2VUZXN0UXVlc3Rpb25JbXBvcnREaWZmO1xuIl19


//////////////////
// WEBPACK FOOTER
// ./src/client/components/practiceTests/PracticeTestQuestionImportDiff.js
// module id = 3301
// module chunks = 0